import { RouteInfo } from './sidebar.metadata';

// Sidebar menu Routes and data
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'Home',
    icon: 'ft-home',
    class: 'has-sub',
    badge: undefined,
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: '/lvl1',
        title: 'LEVEL 1',
        icon: '',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
          {
            path: '/lvl1/characters',
            title: 'Characters',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl1/music',
            title: 'Music',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl1/images',
            title: 'Images',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl1/videos',
            title: 'Videos',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl1/pdf',
            title: 'Pdf',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl1/voices',
            title: 'Voices',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl1/files',
            title: 'Files',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
        ],
      },
      {
        path: '/lvl2',
        title: 'LEVEL 2',
        icon: '',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
          {
            path: '/lvl2/sequences',
            title: 'Sequences',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl2/questions',
            title: 'Questions',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl2/genie-sequences',
            title: 'Genie Sequences',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl2/genie-questions',
            title: 'Genie Questions',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl2/jumbles',
            title: 'Jumbles',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl2/ordering',
            title: 'Ordering',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl2/mtc',
            title: 'Match the Columns',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl2/branches',
            title: 'Branches',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
        ],
      },
      {
        path: '/lvl3',
        title: 'LEVEL 3',
        icon: '',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
          {
            path: '/lvl3/questions',
            title: 'Questions Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/jumbles',
            title: 'Jumbles Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/cross-words-game',
            title: 'Cross Words Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/words-puzzle',
            title: 'Words Puzzle',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/orderings',
            title: 'Ordering Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/classifications',
            title: 'Classification Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/sjt',
            title: 'SJT Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/mtc-game',
            title: 'Match the Columns',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/mini-game',
            title: 'Mini Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/password-game',
            title: 'Password Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/wheel-game',
            title: 'Wheel Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/mario',
            title: 'Mario',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/packing',
            title: 'Packing Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/monopoly',
            title: 'Monopoly',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/angry-bird-game',
            title: 'Angry Bird Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/slider-game',
            title: 'Slider Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/bubble-shooter-game',
            title: 'Bubble Shooter Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/stick-cricket-game',
            title: 'Stick Cricket Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/para-drop-game',
            title: 'Para Drop Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/straight-shooter-game',
            title: 'Straight Shooter Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/pool-game',
            title: 'Pool Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/racing-game',
            title: 'Racing Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/maze-game',
            title: 'Maze Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/fire-pilot-game',
            title: 'Fire Pilot Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/fruit-ninja-game',
            title: 'Fruit Ninja Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/path-finder-game',
            title: 'Pipe Puzzle Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/spot-on-game',
            title: 'Spot On Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/lvl3/snake-ladder-game',
            title: 'Snake Ladder Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
        ],
      },
      {
        path: '',
        title: 'MANAGER READY',
        icon: '',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
          {
            path: '/master-game',
            title: 'Master Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/mg-orders',
            title: 'Master Game Order',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/hint-images',
            title: 'ipad Hint Images',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
        ],
      },
      // {
      //   path: '/master-game',
      //   title: 'Master Game',
      //   icon: '',
      //   class: '',
      //   badge: '',
      //   badgeClass: '',
      //   isExternalLink: false,
      //   submenu: [],
      // },
      // {
      //   path: '/mg-orders',
      //   title: 'Master Game Order',
      //   icon: '',
      //   class: '',
      //   badge: '',
      //   badgeClass: '',
      //   isExternalLink: false,
      //   submenu: [],
      // },
      {
        path: '/orientation-game',
        title: 'Orientation Game',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },
      {
        path: '/learning-game',
        title: 'Learning Game',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },
      {
        path: '',
        title: 'APTITUDE',
        icon: '',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
          {
            path: '/aptitude-game',
            title: 'Aptitude Game',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/aptitude-scores',
            title: 'Aptitude Scores',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
        ],
      },

      {
        path: '/values-game',
        title: 'Values Game',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },

      // hiding companies for now, as it is managed from the v1 dashboard

      // {
      //   path: '/companies',
      //   title: 'Companies',
      //   icon: '',
      //   class: '',
      //   badge: '',
      //   badgeClass: '',
      //   isExternalLink: false,
      //   submenu: [],
      // },
      {
        path: '/divisions',
        title: 'Divisions',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },
      {
        path: '/players',
        title: 'Players',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },

      {
        path: '',
        title: 'FEEDBACK',
        icon: '',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
          {
            path: '/questionset',
            title: 'Question Sets',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
          {
            path: '/feedback-summary',
            title: 'Feedback Summary',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
        ],
      },

      {
        path: '',
        title: 'TTS',
        icon: '',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
          {
            path: '/polly',
            title: 'Polly',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
          },
        ],
      },

      {
        path: '/HomeFirst',
        title: 'Home First',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },
    ],
  },
  {
    path: '/genie-game',
    title: 'Genie Game',
    icon: 'ft-arrow-right',
    class: '',
    badge: undefined,
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [],
  },
  {
    path: '/lemonade',
    title: 'Lemonade',
    icon: 'ft-arrow-right',
    class: 'has-sub',
    badge: undefined,
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: '/lemonade/players',
        title: 'Players',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },
      {
        path: '/lemonade/cohort',
        title: 'Cohort',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },
    ],
  },
  // {
  //   path: '/admins',
  //   title: 'Admins',
  //   icon: 'ft-arrow-right',
  //   class: 'has-sub',
  //   badge: undefined,
  //   badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
  //   isExternalLink: false,
  //   submenu: [
  //     {
  //       path: '/admins/companies',
  //       title: 'Companies',
  //       icon: '',
  //       class: '',
  //       badge: '',
  //       badgeClass: '',
  //       isExternalLink: false,
  //       submenu: [],
  //     },
  //   ],
  // },

  {
    path: 'HomeFirst',
    title: 'Home First',
    icon: 'ft-arrow-right',
    class: '',
    badge: undefined,
    badgeClass: ' ',
    isExternalLink: false,
    submenu: [],
  },
  {
    path: '/asian-paints-values',
    title: 'Asian Paints',
    icon: 'ft-arrow-right',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
  },
  {
    path: '/asian-paints-globetrotter-challenge-integrity',
    title: 'Asian Paints Globetrotter',
    icon: 'ft-arrow-right',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
  },
];
